/* import Api from '@/axios' */
import { marketPlace, website } from "@/axios";

export default {
  getAllCities() {
    const res = marketPlace().get("cities");
    console.log({ cities: res });
    return res;
  },
  getAllContries() {
    return marketPlace().get("countries");
  },
  getGlobalSearch(data) {
    return website().post("user/search", data);
  },
};
